<template>
    <transition name="modal">
        <div id="copyModal" class="modal-mask" v-if="visible">
            <div class="modal-wrapper" @click.self="$emit('close')">
                <div class="modal-container">
                    <div class="modalHeader">
                        <clear-icon class="icon" @click="$emit('close')"/>
                    </div>
                    <div class="modal-content">
                        <div class="row">
                            <div class="col-sm-12">
                                <a class="link" ref="link" :data-clipboard-text="url" href="#copyModal"
                                   @click="copyToClipboard">
                                  <copy-icon class="icon" @click="copyToClipboard"/>
                                    {{$t("copyToClipboard")}}
                                </a>
                            </div>
                            <div class="col-sm-12">
                                <a class="link" ref="link" href="#copyModal"
                                    @click="exportToXLSX">
                                    <copy-icon class="icon" @click="exportToXLSX" />
                                    {{ $t("exportToXLSX") }}
                                </a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import clearIcon from "@/assets/icons/horti_07-cross-12px.svg?inline";
    import copyIcon from "@/assets/icons/horti_09-link-12px.svg?inline";
    import XLSX from 'xlsx';
    import {i18n} from '@/main';

    export default {
        name: "Modal",
        data() {
            return {
                url: "",
                clipboardInstance: null
            };
        },
        props: ["visible", "exportData"],
        components: {clearIcon, copyIcon},
        mounted() {
            this.url = window.location.href;
        },
        methods: {
            copyToClipboard() {
                //Check if URL is equal to the actual URL
                let url = this.url;
                if(this.url !== window.location.href){
                    url = window.location.href;
                    this.url = url;
                }

                //Create a textArea element
                let el = document.createElement('textArea');

                //Set the value of the textArea element
                el.value = url;

                //Make the textArea readonly and hide it
                el.setAttribute('readonly', '');
                el.style.position = 'absolute';
                el.style.left = '-9999px';

                //Add the textArea to the HTML
                document.body.appendChild(el);

                //Check if the user has already selected something
                let selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;

                //Select the created textArea
                el.select();

                //Execute the copy command
                document.execCommand('copy');

                //Remove the textArea component from the HTML
                document.body.removeChild(el);

                //Reselect the selected elements if the user has selected something
                if (selected) {
                    document.getSelection().removeAllRanges();
                    document.getSelection().addRange(selected);
                }

                alert(i18n.t('copyURL'))
            },
            exportToXLSX(){
                //Set fileName
                let filename = "horticulture_calculation.xlsx";

                //Set the data
                let data = this.exportData;

                //Set the sheet name
                let ws_name = "Sheet 01";

                //Create a new workbook and worksheet
                let wb = XLSX.utils.book_new(), ws = XLSX.utils.aoa_to_sheet(data);

                //Add the worksheet to the workbook
                XLSX.utils.book_append_sheet(wb, ws, ws_name);

                //Write the workbook
                XLSX.writeFile(wb, filename);
            }
        }
    };
</script>

<style lang="scss">
    $timing1: 0.3s;
    $timing2: 0.3s;

    .modal-mask {
        position: fixed;
        z-index: map-get($z-index, modal-mask);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba($pink-700, 0.75);
        display: table;
        transition: opacity $timing1 ease;

        .modal-wrapper {
            display: table-cell;
            vertical-align: middle;
            margin: 25px 0;

            .modal-container {
                position: relative;
                width: 100%;
                max-width: 800px;
                margin: 0px auto;
                padding: 20px;
                background-color: $white;
                transition: all $timing1 ease;
                border: 1px solid $dark-grey;
                border-radius: 4px;
                box-shadow: 0px 0px 8px 0px rgba(71, 71, 71, 0.5);

                .modalHeader {
                    width: 100%;

                    .icon {
                        cursor: pointer;
                        color: $black;
                        position: absolute;
                        right: 20px;
                        top: 20px;
                        padding: 10px;
                        width: 32px;
                        height: 32px;
                        z-index:99;

                        &:hover {
                            color: lighten($black, 30%);
                        }
                    }
                }

                .modal-content {
                    padding: 20px 25px 10px;

                    p {
                        line-height: 1.8;
                    }

                    .icon{
                      cursor: pointer;
                      color: $black;
                      height: 32px;
                      padding: 5px;

                      &:hover{
                        color: lighten($black, 30%);
                      }
                    }

                    a {
                        display: block;
                        margin-bottom: 10px;
                        color: $purple-700;
                        text-decoration: underline;

                        &:hover {
                            color: $pink-900;
                        }
                    }
                }
            }
        }
    }

    .modal-enter-active,
    .modal-leave-active {
        transition: opacity 0.2s;

        .modal-container {
            transition: transform 0.3s ease-out;
        }
    }

    .modal-enter,
    .modal-leave-to {
        opacity: 0;

        .modal-container {
            transform: translateY(-10px);
        }
    }

    @media screen and (max-width: 880px) {
        .modal-container {
            max-width: 80% !important;
        }
    }

    @media screen and (max-width: 360px) {
        .modal-mask {
            .modal-wrapper {
                .modal-container {
                    .modal-content {
                        padding: 0 10px;

                        h2 {
                            font-size: 20px !important;
                        }

                        p {
                            font-size: 14px !important;
                        }
                    }
                }
            }
        }
    }
</style>
